import { Component, OnInit, ViewChild } from '@angular/core';
import { Globals } from '../../globals';
import { ProductoService } from '../../servicios/producto.service';
//import { MatTable } from '@angular/material/table';
import {  ElementRef } from '@angular/core';
@Component({
  selector: 'app-productos-carrito',
  templateUrl: './productos-carrito.component.html',
  styleUrls: ['./productos-carrito.component.scss']
})
export class ProductosCarritoComponent implements OnInit {
  @ViewChild('campoDeEntrada') campoDeEntrada: ElementRef;
  constructor(
		private productoService: ProductoService,
		public globals: Globals,
  ) { }

  subscription: any;

  //@ViewChild(MatTable) table: MatTable<any>;

  formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  eliminarProducto( indexProducto ){
    this.globals.configuracion.front.cart.productos.splice( indexProducto, 1 );
    this.setFront();

    //this.table.renderRows();
  }

  setFront(){
    var total = 0;
    for( let x = 0; x < this.globals.configuracion.front.cart.productos.length; x++ ){
      total += this.globals.configuracion.front.cart.productos[x].precio_final_con_impuesto * this.globals.configuracion.front.cart.productos[x].cantidad;
    }
    
    this.globals.configuracion.front.cart.total = this.formatter.format( total );

    this.globals.setDataFront();
  }

  ngOnInit(): void {
    this.campoDeEntrada?.nativeElement?.blur();
    /*
    this.subscription = this.globals.getProductosChangeEmitter().subscribe(
      item => {
        if( this.globals.configuracion.front.cart.productos.length > 0 ){
          this.table.renderRows();
        }
      }
    );
    */
  }

  ngOnDestroy() {
    //this.subscription.unsubscribe();
  }

}
